module.exports = "/_next/static/images/top_micasadeco-1bde775a77634a9d2769a60a1432d35c.jpg";